import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const Thumb = ({ src, alt='', width=100, height=100 }) => {
    const [error, setError] = useState(false)
    const noimg = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_item_img.jpg`
    const errImg = () => {
        setError(true)
    }

    useEffect(() => {
        setError(false)
    }, [src])

    return (
        <>
            {error ? (
                <Error style={{ width: `${width}px`, height: `${height}px`}}>
                    <Img src={noimg} alt='error' />
                </Error>
            ) : (
                <img src={src} alt={alt} onError={errImg} />
            )}
        </>
    )
}

const Error = styled.div`
    text-align: center;
    background: #ecebf1;
`
const Img = styled.img`
    max-width: 100%;
    max-height: 100%;
`

export default Thumb



// WEBPACK FOOTER //
// ./src/estimate_list/components/layout/banner.js